// src/components/RegistrarUsuario.jsx
import { useState } from 'react';
import { registrarUsuario } from '../services/authService';
import './Login.css';
import api from '../services/Api'; // 👈 usa Api.js (A mayúscula)
import GoogleSignIn from './GoogleSignIn';

export default function RegistrarUsuario({ setVista }) {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    password: '',
    confirmarPassword: ''
  });

  const [verificacionToken, setVerificacionToken] = useState('');
  const [codigoIngresado, setCodigoIngresado] = useState('');
  const [correoVerificado, setCorreoVerificado] = useState(false);
  const [mensaje, setMensaje] = useState('');

  const handleChange = (e) => {
    if (e.target.name === 'email') { setCorreoVerificado(false); setVerificacionToken(''); }
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleVerificarCorreo = async () => {
    try {
      // GET /Usuarios/info-tipo?email=...
      const tipo = await api.get('Usuarios/info-tipo', {
        params: { email: formData.email }
      });
      if (tipo.data?.existe) {
        setMensaje('❌ Este correo ya está registrado. Intenta iniciar sesión o usar otro correo.');
        return;
      }

      // POST /Usuarios/verificar-correo  (tu backend recibe [FromBody] string)
      await api.post(
        'Usuarios/verificar-correo',
        JSON.stringify(formData.email),            // <- string JSON, no objeto
        { headers: { 'Content-Type': 'application/json' } }
      );

      setCorreoVerificado(false);
      setVerificacionToken('');
      setMensaje('✅ Código enviado al correo. Revisa tu bandeja de entrada.');
    } catch (error) {
      const msg =
        error?.response?.data ??
        error?.message ??
        '❌ Error al enviar el código';
      setMensaje(typeof msg === 'string' ? msg : '❌ Error al enviar el código');
    }
  };

  const handleValidarCodigo = async () => {
    try {
      const { data } = await api.post('Usuarios/validar-correo', { email: formData.email, codigo: codigoIngresado });
      setVerificacionToken(data.verificacionToken);
      setCorreoVerificado(true);
      setMensaje('✅ Correo verificado correctamente');
    } catch (error) {
      setCorreoVerificado(false);
      setVerificacionToken('');
      setMensaje(typeof error?.response?.data === 'string' ? error.response.data : '❌ No se pudo verificar el código');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!correoVerificado) {
      setMensaje('❌ Debes verificar el correo antes de registrar');
      return;
    }

    if (formData.password !== formData.confirmarPassword) {
      setMensaje('❌ Las contraseñas no coinciden');
      return;
    }

    setMensaje('Registrando...');

    try {
      const usuario = {
        nombre: formData.nombre,
        email: formData.email,
        password: formData.password,
        verificacionToken,
      };

      await registrarUsuario(usuario); // asegúrate de que authService use Api.js también
      setMensaje('✅ Usuario creado exitosamente');

      setTimeout(() => {
        setMensaje('Redirigiendo al login...');
        setTimeout(() => setVista('login'), 1500);
      }, 3000);

    } catch (error) {
      setMensaje(error?.response?.data || error?.message || '❌ Error al registrar');
    }
  };

  return (
    <div className="auth-form-wrap">
      <div className="login-card">
        <p className="auth-card-kicker">Nueva cuenta</p>
        <h2 className="auth-card-title">Registrar usuario</h2>
        <p className="auth-card-subtitle">Verifica tu correo para proteger el acceso a tus estanques.</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <input
            type="text"
            name="nombre"
            placeholder="Nombre completo"
            onChange={handleChange}
            value={formData.nombre}
            required
            className="auth-input"
          />

          <div className="auth-inline-field">
            <input
              type="email"
              name="email"
              placeholder="Correo electrónico"
              onChange={handleChange}
              value={formData.email}
              disabled={correoVerificado}
              required
              className="auth-input"
            />
            <button
              type="button"
              onClick={handleVerificarCorreo}
              className="auth-compact-button"
              disabled={correoVerificado}
            >
              Verificar
            </button>
          </div>

          {!correoVerificado && (
            <div className="auth-inline-field auth-reveal">
              <input
                type="text"
                placeholder="Código recibido"
                value={codigoIngresado}
                onChange={(e) => setCodigoIngresado(e.target.value)}
                className="auth-input"
              />
              <button
                type="button"
                onClick={handleValidarCodigo}
                className="auth-compact-button auth-compact-button--success"
              >
                Validar
              </button>
            </div>
          )}

          <input
            type="password"
            name="password"
            placeholder="Contraseña"
            onChange={handleChange}
            value={formData.password}
            required
            className="auth-input"
          />

          <input
            type="password"
            name="confirmarPassword"
            placeholder="Confirmar contraseña"
            onChange={handleChange}
            value={formData.confirmarPassword}
            required
            className="auth-input"
          />

          <button
            type="submit"
            className="auth-primary-button register-submit"
            title={!correoVerificado ? "Primero verifica tu correo electrónico" : "Crear cuenta"}
          >
            Registrar
          </button>
        </form>

        {mensaje && <p className={`auth-notice ${mensaje.includes('✅') ? 'auth-notice--success' : mensaje.includes('...') ? 'auth-notice--info' : 'auth-notice--error'}`} role="status" aria-live="polite">{mensaje}</p>}

        <div className="auth-divider">
          <span />
          <em>o continúa con</em>
          <span />
        </div>
        <GoogleSignIn />

        <div className="auth-security-label">
          <img src="/jwt-icon.png" alt="jwt" className="h-4" />
          <span>JWT Security</span>
        </div>
      </div>
    </div>
  );
}
